import { render, staticRenderFns } from "./ReportPDF.vue?vue&type=template&id=4ff16bdc&scoped=true&"
import script from "./ReportPDF.vue?vue&type=script&lang=js&"
export * from "./ReportPDF.vue?vue&type=script&lang=js&"
import style0 from "./ReportPDF.vue?vue&type=style&index=0&id=4ff16bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff16bdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})
